import {
  ClipboardCheck,
  FileSearch,
  Handshake,
  Layers,
  Video,
  type LucideIcon,
} from 'lucide-react';

export type StageValue = 'screening' | 'assessment' | 'interview' | 'offer';

type Stage = {
  value: StageValue;
  label: string;
  icon: LucideIcon;
  /** Pill / badge colours for the stage. */
  tone: string;
  /** Solid dot colour. */
  dot: string;
  /** Next-step button shown on an application at this stage. */
  action?: string;
};

/** Hiring pipeline, in order. */
export const STAGES: Stage[] = [
  {
    value: 'screening',
    label: 'Screening',
    icon: FileSearch,
    tone: 'bg-sky-50 text-sky-700 ring-sky-600/15',
    dot: 'bg-sky-500',
  },
  {
    value: 'assessment',
    label: 'Assessment',
    icon: ClipboardCheck,
    tone: 'bg-amber-50 text-amber-700 ring-amber-600/15',
    dot: 'bg-amber-500',
    action: 'Submit assessment',
  },
  {
    value: 'interview',
    label: 'Interview',
    icon: Video,
    tone: 'bg-violet-50 text-violet-700 ring-violet-600/15',
    dot: 'bg-violet-500',
    action: 'View interview',
  },
  {
    value: 'offer',
    label: 'Offer',
    icon: Handshake,
    tone: 'bg-emerald-50 text-emerald-700 ring-emerald-600/15',
    dot: 'bg-emerald-500',
    action: 'View offer',
  },
];

export const ALL_STAGES_ICON = Layers;

export const getStage = (value?: string | null) =>
  STAGES.find((stage) => stage.value === value?.toLowerCase());
